import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UpdateMatchPreferencesDto, UpdateEmailPreferencesDto, UpdateAccountDetailsDto, UpdateExtraAlertDto, AddExtraAlertDto, MarkNewFeatureReadDto, AddCustomerSavedSearchDto, AddCustomerHiddenDialogDto, UpdateAwardsDto, ConsultationSearchModel, AddConsultationDto, QuestionnaireQuestionDto } from '../models/account/account.models';
import { GlobalHttpClient } from '../global.http.client';

@Injectable()
export class AccountService extends BaseService {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    becomeBidManager() {
        var response = this.http.get('account/becomeBidManager');

        return response;
    }

    isBidManager() {
        var response = this.http.get('account/isBidManager');

        return response;
    }

    isEmailValidated() {
        var response = this.http.get('account/isEmailValidated');

        return response;
    }

    isAcknowledged() {
        var response = this.http.get('account/isAcknowledged');

        return response;
    }

    setDocumentsAcknowledged() {
        var response = this.http.get('account/setDocumentsAcknowledged');

        return response;
    }

    markNewFeatureRead(dto: MarkNewFeatureReadDto) {
        return this.http.post('account/markNewFeatureRead', dto);
    }

    getNewFeatures() {
        var response = this.http.get('account/getNewFeatures');

        return response;
    }

    getMatchPreferences() {
        return this.http.get('account/getMatchPreferences');
    }

    getExtraAlertDetails(id: number) {
        return this.http.get(`account/getExtraAlertDetails/${id}`);
    }

    updateMatchPreferences(dto: UpdateMatchPreferencesDto) {
        return this.http.put('account/updateMatchPreferences', dto);
    }

    updateAwards(dto: UpdateAwardsDto) {
        return this.http.put('account/updateAwards', dto);
    }

    updateExtraAlert(dto: UpdateExtraAlertDto) {
        return this.http.put('account/updateExtraAlert', dto);
    }

    addExtraAlert(dto: AddExtraAlertDto) {
        return this.http.post('account/addExtraAlert', dto);
    }

    getEmailPreferences() {
        return this.http.get('accountDetails/emailPreferences');
    }

    getExtraAlerts() {
        return this.http.get('account/getExtraAlerts');
    }

    getCustomerSavedSearches() {
        return this.http.get('account/getCustomerSavedSearches');
    }

    addCustomerSavedSearch(dto: AddCustomerSavedSearchDto) {
        return this.http.post('account/addCustomerSavedSearch', dto);
    }

    addCustomerHiddenDialog(dto: AddCustomerHiddenDialogDto) {
        return this.http.post('account/addCustomerHiddenDialog', dto);
    }

    deleteAlert(id: number) {
        var response = this.http.deleteWithParams('account/deleteExtraAlert', { Id: id });

        return response;
    }

    deleteCustomerSavedSearch(id: number) {
        var response = this.http.deleteWithParams('account/deleteCustomerSavedSearch', { Id: id });

        return response;
    }

    updateEmailPreferences(dto: UpdateEmailPreferencesDto) {
        return this.http.put('accountDetails/emailPreferences', dto);
    }

    getAccountDetails() {
        return this.http.get('accountDetails');
    }

    updateAccountDetails(dto: UpdateAccountDetailsDto) {
        return this.http.put('accountDetails', dto);
    }

    requestDomainChange(requestedAddress: string, password: string) {
        return this.http.post('accountDetails/requestDomainChange',
            { requestedAddress: requestedAddress, validationPassword: password });
    }

    archive() {
        var response = this.http.get('account/archive');

        return response;
    }

    bookConsultation(dto: AddConsultationDto) {
        return this.http.post('account/addConsultation', dto);
    }

    getConsultationTimeslots(request: ConsultationSearchModel) {
        return this.http.getWithParams('account/getConsultationTimeslots', request);
    }

    recordConsultationClick() {
        var response = this.http.get('account/recordConsultationClick');

        return response;
    }

    getQuestionnaireQuestions() {
        return this.http.get('account/getQuestionnaireQuestions');
    }

    submitQuestionnaire(dto: QuestionnaireQuestionDto[]) {
        return this.http.post('account/submitQuestionnaire', dto);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/account.service.ts